module.exports = __webpack_public_path__ + "img/wx.92429ec0.png";